import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Add Process, Folder, etc", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Search",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
          }, null, 544), [
            [_vModelText, _ctx.searchQ]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.toSlug) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: node.Slug
              }, _toDisplayString(node.Name), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.formData.toSlug]
          ]),
          _createElementVNode("input", {
            class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
            type: "submit",
            value: "Submit",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}